module.exports = __webpack_public_path__ + "img/erin-e-adams.1fc59044.png";